// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"12e72e82","703":"34cf80b0","787":"bff9be08"}[chunkId] + ".chunk.js";
};